module.exports = "/images/our-blog.jpg";